import { render, staticRenderFns } from "./ProductLightm20.vue?vue&type=template&id=536383c3&scoped=true"
import script from "./ProductLightm20.vue?vue&type=script&lang=js"
export * from "./ProductLightm20.vue?vue&type=script&lang=js"
import style0 from "./ProductLightm20.vue?vue&type=style&index=0&id=536383c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536383c3",
  null
  
)

export default component.exports